import { LogoSymbol } from './LogoSymbol.js';
import { LogoWording } from './LogoWording.js';
import { LogoWrapper } from './styled.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var Logo = function Logo(_ref) {
  var className = _ref.className,
      display = _ref.display,
      isDarkTheme = _ref.isDarkTheme,
      _ref$symbolSize = _ref.symbolSize,
      symbolSize = _ref$symbolSize === void 0 ? '24px' : _ref$symbolSize,
      _ref$wordingSize = _ref.wordingSize,
      wordingSize = _ref$wordingSize === void 0 ? '96px' : _ref$wordingSize;
  return jsxs(LogoWrapper, {
    className: className,
    children: [jsx(LogoSymbol, {
      size: symbolSize,
      isDarkTheme: isDarkTheme
    }), jsx(LogoWording, {
      display: display,
      size: wordingSize,
      isDarkTheme: isDarkTheme
    })]
  });
};

export { Logo };
